/* eslint-disable */
import { useEffect, useMemo, useState } from "react";
import { useRecoilValue } from "recoil";
import { DebitCard, NEFT, NetBanking, UPI } from "../../assets/Icons";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchNeftBankDetails,
  getBankNames,
  pennyDropAPI,
  razorPayResponse,
  requestRazor,
  requestRazorLink,
} from "../../services/paymentOptions";
import { selectedPurpose, selectVendor, transactionDetails, userDetails, vendorCodes } from "../../store";
import { UserDetails, UserTransactionDetails } from "../../store/store";
import { Modals } from "./Modals";
import PaymentPageProps from "./Payment";
import clsx from "clsx";
import { Mixpanel } from "../../constants/mixpanel";
import { toast, ToastContainer } from "react-toastify";
import { formatNumber } from "../../utils";

declare global {
  interface Window {
    Cashfree?: any;
    Razorpay?: any;
  }
}

const validPurposes = ["S1301", "S1302", "Family Maintenance", "Personal Gift or Donation"];

const Payment = () => {
  const state: any = useLocation().state;

  const payButton =
    "w-[201px] h-[210px] bg-[#E7E7E7] rounded-lg flex flex-col space-y-3 justify-center items-center cursor-pointer hover:bg-gray-300 hover:scale-105 transition-all";
  const transactionData: UserTransactionDetails = useRecoilValue(transactionDetails);
  const userData: UserDetails = useRecoilValue(userDetails);
  const vendorUserDetails = JSON.parse(localStorage.getItem("vendorUserDetails") || "{}");
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [bankName, setBankName] = useState<string>("");
  const [bankList, setBankList] = useState([""]);
  const [accountNumber, setAccountNumber] = useState<string>("");
  const [ifscCode, setIfscCode] = useState<string>("");
  const [upiId, setUpiId] = useState<string>("");
  const [pennyError, setPennyError] = useState<string>("");
  const [cashfreeBackdrop, setCashfreeBackdrop] = useState<boolean>(false);
  const [upiLinkId, setUpiLinkId] = useState<string>("");
  const [linkAccountNumber, setLinkAccountNumber] = useState<string>("");
  const [linkIfscCode, setLinkIfscCode] = useState<string>("");
  const [neftBankDetails, setNeftBankDetails] = useState({} as PaymentPageProps.neftBankDetails);
  const [sendingAmount, setSendingAmount] = useState<any>();
  const [transactionId, setTransactionId] = useState<any>();
  const referrerVendorCode = useRecoilValue(selectVendor);
  const [onlyNeft, setOnlyNeft] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const selectedPurposeCode = useRecoilValue(selectedPurpose);
  const [showOtherPayment, setShowOtherPayment] = useState<boolean>(false);

  const location = useLocation();
  const navigate = useNavigate();


  useMemo(() => {
    setOnlyNeft(validPurposes.includes(location.state?.purpose));
  }, [location]);

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      event.preventDefault();
      sessionStorage.setItem("navigatingFromPage", "true");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const shouldNavigate = sessionStorage.getItem("navigatingFromPage") === "true";
      if (shouldNavigate) {
        sessionStorage.removeItem("navigatingFromPage");
        navigate("/remittance", { replace: true });
      }
    }, 500);
  }, [navigate]);

  useEffect(() => {
    if (state?.payAmount && state?.id) {
      setSendingAmount(state?.payAmount);
      setTransactionId(state?.id);
    } else {
      setSendingAmount(transactionData?.total_pay);
      setTransactionId(transactionData?.id_transaction);
    }
  }, [state, transactionData]);

  useEffect(() => {
    getBankNames(currentUser).then((response: any) => {
      const bankArray: string[] = [];
      response.data.banks.forEach((item: any) => bankArray.push(item.bankName));
      setBankList(bankArray);
    });
    // fetchNeftBankDetails(referrerVendorCode?.vendorCode||location?.state?.vendorCode)
    //   .then((response) => setNeftBankDetails(response?.data))
    //   .catch((error) => {
    //     console.error(error);
    //   });
  }, [location]);

  const handleNetBanking = () => {
    setIsLoading(true);
    const body = {
      cusAcc: accountNumber,
      ifscCode: ifscCode,
      isVpa: false,
      transactionID: transactionId,
      userId: 0,
      userKey: vendorUserDetails.userKey,
      vpa: "",
    };
    pennyDropAPI(body)
      .then(() => {
        const body = {
          accNum: accountNumber,
          ifsc: ifscCode,
          paymentMode: "NET_BANKING",
          transactionID: transactionId,
          userId: 0,
          userKey: vendorUserDetails.userKey,
        };
        requestRazor(body).then((response) => {
          if (response?.data?.openRazorpay === false) {
            setIsModalOpen("");
            const dropConfig = {
              components: ["netbanking"],
              orderToken: response?.data?.order,
              onSuccess: function (data: any) {
                const body = {
                  razorpay_order_id: data.order.orderId,
                  razorpay_payment_id: data.transaction.transactionId,
                  isRazorPay: false,
                  razorpay_signature: "",
                };
                razorPayResponse(body)
                  .then((response: any) => {
                    if (response.status === 200) {
                      localStorage.setItem("matchingUrl", response.data.redirectUrl);
                      window.location.href = "/confirmation";
                      setCashfreeBackdrop(!cashfreeBackdrop);
                    }
                  })
                  .catch(() => {
                    setCashfreeBackdrop(false);
                  });
              },
              onFailure: () => {
                setCashfreeBackdrop(false);
              },
              style: {
                backgroundColor: "#ffffff",
                color: "#11385b",
                fontFamily: "Lato",
                fontSize: "14px",
                errorColor: "#ff0000",
                theme: "light",
              },
            };
            const cashfree: any = new window.Cashfree();
            const paymentElement: any = document.getElementById("payment-form");
            if (paymentElement.firstChild) paymentElement.firstChild.remove();
            cashfree.initialiseDropin(paymentElement, dropConfig);
            setCashfreeBackdrop(true);
          } else {
            const options = {
              key: response?.data.key,
              amount: response?.data.amount, // amount in paisa
              name: "K2 Remit",
              description: "Remit Transaction",
              // image: logo,
              order_id: response?.data.orderID,
              handler: async function (response: any) {
                const data = {
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_signature: response.razorpay_signature,
                  isRazorPay: true,
                };
                razorPayResponse(data)
                  .then((response: any) => {
                    if (response.status === 200) {
                      setIsModalOpen("");
                      localStorage.setItem("matchingUrl", response.data.redirectUrl);
                      window.location.href = "/confirmation";
                    }
                  })
                  .catch((reason: any) => {
                    // eslint-disable-next-line no-console
                    console.error(JSON.stringify(reason));
                  });
              },
              modal: {
                ondismiss: function () {
                  window.location.reload();
                },
              },
              prefill: {
                name: userData.firstName,
                email: userData.email,
              },
              notes: {
                address: "MoneyHop",
              },
              theme: {
                color: "#3B74FA",
              },
              method: {
                netbanking: true,
              },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
          }
        });
      })
      .catch((error) => {
        setPennyError(error?.response?.data?.error?.type);
        setTimeout(() => {
          setPennyError("");
        }, 5000);
      })
      .finally(() => setIsLoading(false));
  };

  const handleSendUpiLink = () => {
    setIsLoading(true);
    const body = {
      cusAcc: accountNumber,
      ifscCode: ifscCode,
      isVpa: false,
      transactionID: transactionId,
      userId: 0,
      userKey: vendorUserDetails.userKey,
      vpa: "",
    };

    pennyDropAPI(body)
      .then((response) => {
        if (response?.data?.success === true) {
          const body = {
            accNum: accountNumber,
            ifsc: ifscCode,
            paymentMode: "UPI",
            transactionID: transactionId,
            userId: 0,
            userKey: vendorUserDetails.userKey,
          };
          requestRazorLink(body)
            .then((response) => {
              // eslint-disable-next-line no-console
            })
            .catch((error) => {
              setPennyError(error?.response?.data?.error?.type);
              // eslint-disable-next-line no-console
              console.error(error?.response?.data?.error?.type);
            });
        }
      })
      .catch((error) => {
        setPennyError(error?.response?.data?.error?.type);
      })
      .finally(() => setIsLoading(false));
  };

  const handleSendNetBankingLink = () => {
    setIsLoading(true);
    const body = {
      cusAcc: accountNumber,
      ifscCode: ifscCode,
      isVpa: false,
      transactionID: transactionId,
      userId: 0,
      userKey:
        location.state.from === "HistoryPage"
          ? location?.state?.userKey
          : vendorUserDetails.userKey,
      vpa: "",
    };
    pennyDropAPI(body)
      .then((response) => {
        if (response?.data?.success === true) {
          const body = {
            accNum: accountNumber,
            ifsc: ifscCode,
            paymentMode: "NET_BANKING",
            transactionID: transactionId,
            userId: 0,
            userKey:
              location.state.from === "HistoryPage"
                ? location?.state?.userKey
                : vendorUserDetails.userKey,
          };
          requestRazorLink(body)
            .then((response) => {
              // eslint-disable-next-line no-console
              toast.success("Link sent successfully to remitter's mobile number");
              navigate("/confirmation");
            })
            .catch((error) => {
              // eslint-disable-next-line no-console
              setPennyError(error?.response?.data?.error?.type);

              console.error(error?.response?.data?.error?.type);
            });
        }
      })
      .catch((error) => {
        setPennyError(error?.response?.data?.error?.type);
        setTimeout(() => {
          setPennyError("");
        }, 5000);
      })
      .finally(() => setIsLoading(false));
  };

  const handleUpi = () => {
    const body = {
      cusAcc: accountNumber,
      ifscCode: ifscCode,
      isVpa: true,
      transactionID: transactionId,
      userId: 0,
      userKey: vendorUserDetails.userKey,
      vpa: upiId,
    };
    pennyDropAPI(body)
      .then(() => {
        const body = {
          accNum: accountNumber,
          ifsc: ifscCode,
          paymentMode: "UPI",
          transactionID: transactionId,
          userId: 0,
          userKey: vendorUserDetails.userKey,
        };
        requestRazor(body).then((response) => {
          if (response?.data?.openRazorpay === false) {
            setIsModalOpen("");
            const dropConfig = {
              components: ["upi"],
              orderToken: response?.data?.order,
              onSuccess: function (data: any) {
                const body = {
                  razorpay_order_id: data.order.orderId,
                  razorpay_payment_id: data.transaction.transactionId,
                  isRazorPay: false,
                  razorpay_signature: "",
                };
                razorPayResponse(body)
                  .then((response: any) => {
                    if (response.status === 200) {
                      localStorage.setItem("matchingUrl", response.data.redirectUrl);
                      window.location.href = "/confirmation";
                      setCashfreeBackdrop(!cashfreeBackdrop);
                    }
                  })
                  .catch(() => {
                    setCashfreeBackdrop(false);
                  });
              },
              onFailure: () => {
                setCashfreeBackdrop(false);
              },
              style: {
                backgroundColor: "#ffffff",
                color: "#11385b",
                fontFamily: "Lato",
                fontSize: "14px",
                errorColor: "#ff0000",
                theme: "light",
              },
            };
            const cashfree: any = new window.Cashfree();
            const paymentElement: any = document.getElementById("payment-form");
            if (paymentElement.firstChild) paymentElement.firstChild.remove();
            cashfree.initialiseDropin(paymentElement, dropConfig);
            setCashfreeBackdrop(true);
          } else {
            const options = {
              key: response?.data.key,
              amount: response?.data.amount, // amount in paisa
              name: "K2 Remit",
              description: "Remit Transaction",
              // image: logo,
              order_id: response?.data.orderID,
              handler: async function (response: any) {
                const data = {
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_signature: response.razorpay_signature,
                  isRazorPay: true,
                };
                razorPayResponse(data)
                  .then((response: any) => {
                    if (response.status === 200) {
                      setIsModalOpen("");
                      localStorage.setItem("matchingUrl", response.data.redirectUrl);
                      window.location.href = "/confirmation";
                    }
                  })
                  .catch((reason: any) => {
                    // eslint-disable-next-line no-console
                    console.error(JSON.stringify(reason));
                  });
              },
              modal: {
                ondismiss: function () {
                  window.location.reload();
                },
              },
              prefill: {
                name: userData.firstName,
                email: userData.email,
              },
              notes: {
                address: "MoneyHop",
              },
              theme: {
                color: "#3B74FA",
              },
              method: {
                netbanking: true,
              },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
          }
        });
      })
      .catch((error) => {
        setPennyError(error?.response?.data?.error?.type);
        setTimeout(() => {
          setPennyError("");
        }, 5000);
      });
  };

  const validPurposeValues = ["S1301", "S1302"];

  useEffect(() => {
    if (
      !validPurposeValues.includes(selectedPurposeCode?.purposeCode || location?.state?.purpose)
    ) {
      setShowOtherPayment(true);
    }
  }, [selectedPurposeCode?.purposeCode, location?.state?.purpose]);

  return (
    <div className="flex flex-col p-6 mt-[117px] w-[1370px]">
      <ToastContainer position="top-center" />
      <div id="header" className="flex flex-col items-center">
        <span className="text-[32px] font-light">
          Payable Amount: {formatNumber(sendingAmount)} INR
        </span>
        <span className="text-[24px]">Select the mode of payment</span>
      </div>
      <div id="boxes" className="flex justify-center mt-32 space-x-20">
        <div
          id="neft"
          onClick={() => {
            setIsModalOpen("neft");
            Mixpanel.track("NEFT_clicked");
          }}
          className={clsx(payButton, "neft-button")}
        >
          <NEFT />
          <span className="font-semibold neft-text">NEFT/RTGS</span>
        </div>
        {showOtherPayment && (
          <>
            <div id="link" onClick={() => setIsModalOpen("link")} className={payButton}>
              <DebitCard />
              <span className="font-semibold">Send Payment Link</span>
            </div>
            <div id="netBanking" onClick={() => setIsModalOpen("netBanking")} className={payButton}>
              <NetBanking />
              <span className="font-semibold">Net Banking</span>
            </div>
          </>
        )}
        {/* <div id="upi" onClick={() => setIsModalOpen("upi")} className={payButton}>
          <UPI />
          <span className="font-semibold">UPI</span>
        </div> */}
      </div>
      <div
        style={{
          position: "fixed",
          left: "0px",
          top: "0px",
          height: "100vh",
          width: "100vw",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: cashfreeBackdrop ? "block" : "none",
        }}
      >
        <div
          style={{
            position: "fixed",
            left: "50%",
            top: "50%",
            width: "500px",
            height: "500px",
            transform: "translate(-50%, -50%)",
          }}
        >
          <div id="payment-form" style={{ height: "500px", width: "500px" }}></div>
        </div>
      </div>
      <Modals
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        bankList={bankList}
        bankName={bankName}
        setBankName={setBankName}
        accountNumber={accountNumber}
        setAccountNumber={setAccountNumber}
        ifscCode={ifscCode}
        setIfscCode={setIfscCode}
        netBankingHandle={handleNetBanking}
        upiId={upiId}
        isLoading={isLoading}
        setUpiId={setUpiId}
        upiHandle={handleUpi}
        handleSendNetBankingLink={handleSendNetBankingLink}
        errorMessage={pennyError}
        setLinkAccountNumber={setLinkAccountNumber}
        setLinkIfscCode={setLinkIfscCode}
        setUpiLinkId={setUpiLinkId}
        upiLinkId={upiLinkId}
        accNumLink={linkAccountNumber}
        ifscLink={linkIfscCode}
        sendUpiLinkHandle={handleSendUpiLink}
        neftBankDetails={neftBankDetails}
        vendorCode={referrerVendorCode?.vendorCode || location?.state?.vendorCode}
        onlyNeft={onlyNeft}
        selectedPurposeCode={selectedPurposeCode}
      />
    </div>
  );
};

export default Payment;
